import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Articles", href: "/articles" },
  { label: "Topics", href: "/topics/newcomers" },
  { label: "Tools", href: "/tools" },
  { label: "Videos", href: "/videos" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F9F8F6]/90 shadow-sm border-b border-[#E7E5E4]"
          : "bg-[#F9F8F6] border-b border-[#E7E5E4]"
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Brand */}
        <Link to="/" className="flex flex-col leading-none group" data-testid="brand-logo">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-[#D4A373]">
            Straight Talk Money
          </span>
          <span className="font-display text-[#1B4332] font-bold text-lg leading-tight">
            with Michael
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-7" data-testid="desktop-nav">
          {NAV.map((n) => (
            <Link
              key={n.href}
              to={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors duration-200 ${
                location.pathname === n.href || location.pathname.startsWith(n.href + "/")
                  ? "text-[#1B4332]"
                  : "text-[#57534E] hover:text-[#1B4332]"
              }`}
            >
              {n.label}
            </Link>
          ))}
          <Link
            to="/articles"
            data-testid="nav-newsletter-cta"
            className="bg-[#1B4332] text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-[#2D6A4F] transition-colors"
          >
            Newsletter
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-[#1C1C1C] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-btn"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile nav drawer */}
      {open && (
        <div
          className="md:hidden bg-white border-t border-[#E7E5E4] px-6 py-4 flex flex-col gap-4"
          data-testid="mobile-nav"
        >
          {NAV.map((n) => (
            <Link
              key={n.href}
              to={n.href}
              data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              className="text-[#1C1C1C] font-medium text-base py-1 border-b border-[#F2EFE9]"
            >
              {n.label}
            </Link>
          ))}
          <Link
            to="/articles"
            className="bg-[#1B4332] text-white text-center font-semibold px-4 py-2.5 rounded-md mt-2"
          >
            Get the Newsletter
          </Link>
        </div>
      )}
    </header>
  );
}
